import Icon from '../../../components/AppIcon';

const StatsOverview = () => {
  const stats = [
    {
      icon: 'Users',
      value: '500+',
      label: 'Happy Clients',
      color: 'text-primary'
    },
    {
      icon: 'Star',
      value: '4.9/5',
      label: 'Average Rating',
      color: 'text-accent'
    },
    {
      icon: 'Building2',
      value: '50+',
      label: 'Commercial Projects',
      color: 'text-secondary'
    },
    {
      icon: 'Clock',
      value: '30+',
      label: 'Years Experience',
      color: 'text-success'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-12">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg border border-border p-4 md:p-6 text-center hover:shadow-elevated transition-shadow duration-300"
        >
          <div className={`inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-muted mb-3 md:mb-4 ${stat?.color}`}>
            <Icon name={stat?.icon} size={24} className="md:w-8 md:h-8" />
          </div>
          <p className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-1 md:mb-2">
            {stat?.value}
          </p>
          <p className="text-muted-foreground text-xs md:text-sm font-body">
            {stat?.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;